export const LoginStrategy = {
    Finish: 'Finish',
    IncorrectUsernamePassword: 'IncorrectUsernamePassword',
    IncorrectGesturePassword: 'IncorrectGesturePassword',
    AccountClosed: 'AccountClosed',
    AccountSuspend: 'AccountSuspend',
    Validation: 'Validation',
    AccountNoCredit: 'AccountNoCredit',
    AccountLocked: 'AccountLocked',
    LoginTooOften: 'LoginTooOften',
    FailedCode: 'FailedCode',
    UnallowedLocation: 'UnallowedLocation',
    UnderMaintenance: 'UnderMaintenance',
    GestureClosed: 'GestureClosed',
    GesturepwdIsNull: 'GesturepwdIsNull',
    NotSupportGesture: 'NotSupportGesture',
    TicketIdIsZero: 'TicketIdIsZero',
    RedirectRulesPage: 'RedirectRulesPage',
    WrongDomain: 'WrongDomain', // 25
    InvalidRoleId: 'InvalidRoleId', // 30
    IncorrectUnPw: 'IncorrectUnPw', // 40
    UpdateCustomerStatusToCasinoAdminDBFailed: 'UpdateCustomerStatusToCasinoAdminDBFailed', // 43
    RequestBodyHasNullValue: 'RequestBodyHasNullValue', // 102
    RobotBlockOver5: 'RobotBlockOver5',
    RefKeyCloseLoginIsTrue: 'RefKeyCloseLoginIsTrue', // 395
    IsDeniedIp: 'IsDeniedIp', // 396
    LoginTooOftenPleaseWait5Minutes: 'LoginTooOftenPleaseWait5Minutes', // 397
    BadRequest: 'BadRequest', // 400
    NotInternalIp: 'NotInternalIp', // 407
    InternalServerError: 'InternalServerError', // 500
    UnExceptError: 'UnExceptError',
};

export const LoginErrorCode = {
    Success: 0,
    IncorrectUsernamePassword: 2,
    TicketIdIsZero: 4, // 789y account can not login to nova88 site.
    AccountClosed: 20,
    AccountSuspend: 22,
    AccountNoCredit: 23,
    AccountLocked: 24,
    IncorrectGesturePassword: 41,
    LoginTooOften: 45,
    FailedCode: 49,
    UnallowedLocation: 50,
    RequestBodyHasNullValue: 102,
    UnderMaintenance: 101,
    NotSupportGesture: 113,
    LoginCountIsBiggerThanMaximumValue: 398,
    GestureClosed: 401,
    GesturepwdIsNull: 402,
    NotInternalIp: 407,
    RedirectRulesPage: 408, // 會員第一次登入
    WrongDomain: 25,
    InvalidRoleId: 30,
    IncorrectUnPw: 40,
    UpdateCustomerStatusToCasinoAdminDBFailed: 43,
    RobotBlockOver5: 394,
    RefKeyCloseLoginIsTrue: 395,
    IsDeniedIp: 396,
    LoginTooOftenPleaseWait5Minutes: 397,
    BadRequest: 400,
    InternalServerError: 500,
};

export const LoginErrorMessage = {
    IncorrectUsernamePassword: 'incorrect_un_pw',
    IncorrectUsernamePasswordWithErrorCount: 'lbl_LoginFailTimes',
    IncorrectUsernamePasswordWithOldPassword: 'lbl_LoginFailOldPassword',
    IncorrectGesturePassword: 'lbl_GesturePWD_incrctXattempts',
    AccountClosed: 'errlogin_AC_Closed',
    AccountSuspend: 'errlogin_AC_suspend',
    AccountLocked: 'errlogin_AC_Locked',
    LoginTooOften: 'errlogin_toooften',
    FailedCode: 'errlogin_failedcode',
    UnallowedLocation: 'not_allow_IP',
    GestureClosed: 'lbl_GesturePWD_disabled',
    NotInternalIp: 'lbl_NotInternalIp',
    TicketIdIsZero: 'lbl_SessionTO',
    RedirectRulesPage: 'RedirectRulesPage',
    WrongDomain: 'lbl_WrongDomain', // 25
    InvalidRoleId: 'lbl_InvalidRoleId', // 30
    IncorrectUnPw: 'incorrect_un_pw', // 40
    UpdateCustomerStatusToCasinoAdminDBFailed: 'lbl_UpdateCustomerStatusToCasinoAdminDBFailed', // 43
    UnderMaintenance: 'lbl_IsDownTime', // 101
    RequestBodyHasNullValue: 'lbl_RequestBodyHasNullValue', // 102
    RobotBlockOver5: 'errlogin_robotBlockOver5',
    RefKeyCloseLoginIsTrue: 'lbl_RefKeyCloseLoginIsTrue', // 395
    IsDeniedIp: 'lbl_IsDeniedIp', // 396
    LoginTooOftenPleaseWait5Minutes: 'lbl_LoginTooOftenPleaseWait5Minutes', // 397
    BadRequest: 'lbl_BadRequest', // 400
    InternalServerError: 'lbl_InternalServerError', // 500
};

export const CheckLoginCodeErrorCode = {
    Success: 0,
    CheckLoginCodeFail: 399,
};

export const CheckLoginCodeStrategy = {
    MakeSuccess: 'MakeSuccess',
    RefreshLoginCode: 'RefreshLoginCode',
};

export const CheckLoginCodeErrorMessage = {
    InvalidLoginCode: 'lbl_InputInvalidCode',
    EmptyLoginCode: 'lbl_EnterValidCode',
    LimitPassword: 'lbl_LoginAlert',
};

export const LoginInputMaxLength = {
    usernameMaxLength: 30,
    passwordMaxLength: 11,
    loginCodeMaxLength: 4,
};
